import { render } from "./HomeView.vue?vue&type=template&id=18856167"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=18856167&lang=css"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__